// extracted by mini-css-extract-plugin
module.exports = {"btn-overrides":"styles_btn-overrides__1M6VD","shopini-icon":"styles_shopini-icon__1cTcu"};